import BoostAiChat from '../_common/boost_ai_chat';

export default function LiveChat(disabled = false, common = {}, trackingParams = {}) {
  this.disabled = disabled;
  this.common = common;

  if (this.disabled) {
    return;
  }

	this.isDisabled = () => {
		return this.disabled;
	}

	this.isEnabled = () => {
		return !this.disabled;
	}

	this.initiateBoostAiChat = () => {
		this.boostAiChat = new BoostAiChat(common, trackingParams);
		if (this.isEnabled()) {
			this.boostAiChat.init();
		}
	}

	this.expand = () => {
		if (this.isEnabled()) {
			this.boostAiChat.open();
		}
	}

	this.showPaymentFailed = () =>   {
		this.boostAiChat.triggerPaymentFailedFlow();
	}

  this.initiateBoostAiChat();
}
